import apiCreator from './util/ApiCreator';

const api = apiCreator('/api/channel');

export default {
    getShippingMethods(channelId){
        return api.get(`/${channelId}/shipping-methods`);
    },
}
